require("./Table.less");

const React = require("react");

const QuestionType = require("~/types/Question.js").PropType;
const Comment = require("../Comment/Comment.jsx");
const Task = require("../Task/Task.jsx"); 
const DiskButton = require("../DiskButton/DiskButton.jsx");

const NewAnswerSelection = require("~/types/AnswerSelection.js").New;

const Table = React.createClass({
    propTypes: {
        Question: QuestionType.isRequired,
        OnAnswerChange: React.PropTypes.func.isRequired
    },

    getInitialState() {
        const hasAnswerSelections = (this.props.Question.AnswerSelections || []).length > 0;
        const expectedLength = this.props.Question.AnswerOptions.length;

        if (hasAnswerSelections) {
            const asAnswerSelection = ((sel) => {
                if (typeof (sel.SelectionText || "") === "string") {
                    sel.SelectionText = [sel.SelectionText || ""];
                }

                const newSelections = this.GetRowValues(sel.SelectionText);

                const mapped = NewAnswerSelection(
                    sel.SelectionText,
                    sel.AdditionalComment,
                    sel.GUID,
                    sel.SelectionScoreValue);

                return mapped;
            });

            const selections = this.props.Question.AnswerSelections
                .map(asAnswerSelection);

            return {
                AnswerSelections: selections,
                AdditionalComment: this.props.Question.AdditionalComment, 
                Task: this.props.Question.Task
            };
        }
        else {
            const emptyRowValues = this.GetRowValues();

            return {
                AnswerSelections: [NewAnswerSelection(emptyRowValues)],
                AdditionalComment: this.props.Question.AdditionalComment, 
                Task: this.props.Question.Task 
            };
        }
    },

    render() {
        const showCommentField = this.props.Question.IncludeComment;
        const tableHeadings = this.props.Question.AnswerOptions.map(this.GetHeading);
        const numberOfColumns = this.props.Question.AnswerOptions.length;

        return (<div className="cs-Table">
                <header className="cs-Table__question"
                        dangerouslySetInnerHTML={{ __html: this.props.Question.DisplayHTML }}></header>
                <table id="table" className="table table-bordered cs-Table__table">
                    <thead>
                        <tr>
                            <td></td>
                            {tableHeadings}
                        </tr>
                    </thead>
                    <tbody>
                        {this.GetRows()}
                    </tbody>
                    <tfoot>
                        <tr>
                            <td></td>
                            <td colSpan={numberOfColumns} className="cs-Table__add-row-box">
                                <button className="cs-Table__add-row-btn btn btn-success"
                                        onClick={this.AddRow}>Add Row</button>
                            </td>
                        </tr>
                    </tfoot>
                </table>
                {showCommentField && (
                    <Comment OnChange={this.OnCommentChange} Comment={this.state.AdditionalComment} />)}
                <Task OnChange={this.OnTaskChange} Task={this.state.Task}></Task>
        </div>);
    },

    GetRows() {
        let rows = this.state.AnswerSelections.map(this.GetRow);

        return rows;
    },

    GetRow(selection, i) {
        let cols = this.props.Question.AnswerOptions.map((option, j) => {
            const cellChange = (e) => {
                const value = e.target.value;

                this.UpdateCell(value, i, j);
            }

            const value = selection.SelectionText[j] || "";
            if(j===0) {
                return (<td key={i, j} className="cs-Table__data">
                    <input className="form-control cs-Table__data__input"
                            ref={(ref) => this.newRow = ref}
                            value={value} onChange={cellChange} />
                    <p className="cs-Table__data__input--print">
                        {value}
                    </p>
            </td>);
                }
            else {
            return (<td key={i, j} className="cs-Table__data">
                        <input className="form-control cs-Table__data__input"
                               value={value} onChange={cellChange} />
                        <p className="cs-Table__data__input--print">
                            {value}
                        </p>
            </td>);
            }
        });

        const removeRow = () => {
            this.RemoveRow(i);
        };

        return (<tr key={i }>
                <td>
                    <DiskButton className="btn btn-danger"
                                onClick={removeRow}
                                MarkClassName="glyphicon glyphicon-remove" />                    
                </td>
            {cols}
        </tr>);
    },

    GetHeading(answerOption) {
        return (<th key={answerOption.GUID} className="cs-Table__data">
            {answerOption.DisplayText}
        </th>)
    },

    GetRowValues(baseVals) {
        baseVals = baseVals || [];

        const row = this.props.Question.AnswerOptions.map((op, i) => {
            return baseVals[i] || "";
        });

        return row;
    },

    UpdateCell(newValue, rowID, columnID) {
        const newAnswers = this.state.AnswerSelections.slice();

        newAnswers[rowID].SelectionText[columnID] = newValue;

        this.props.OnAnswerChange(newAnswers, this.state.AdditionalComment);

        this.setState({
            AnswerSelections: newAnswers
        });
    },

    AddRow() {
        let answers = this.state.AnswerSelections.slice();

        const newCols = this.GetRowValues();

        answers.push(NewAnswerSelection(newCols));

        this.props.OnAnswerChange(answers, this.state.AdditionalComment);

        this.setState({
            AnswerSelections: answers
        },
        () => {
            this.newRow.focus();
        });
    },

    RemoveRow(i) {
        if (this.state.AnswerSelections.length > i) {
            let answers = [
                ...this.state.AnswerSelections.slice(0, i),
                ...this.state.AnswerSelections.slice(i + 1,
                    this.state.AnswerSelections.length)
            ];

            if (answers.length === 0) {
                const newCols = this.GetRowValues();

                answers.push(NewAnswerSelection(newCols));
            }

            this.props.OnAnswerChange(answers, this.state.AdditionalComment);

            this.setState({
                AnswerSelections: answers
            });
        }
    },

    OnCommentChange(e) {
        this.props.OnAnswerChange(this.state.AnswerSelections, e.target.value, this.state.Task);

        this.setState({
            AdditionalComment: e.target.value
        });
    },

    OnTaskChange(e) { 
        this.props.OnAnswerChange(this.state.AnswerSelections, this.state.AdditionalComment, e.target.value); 

        this.setState({
            Task: e.target.value
        })
    }
});

module.exports = Table;


// WEBPACK FOOTER //
// ./src/components/Table/Table.jsx